const initialState = {
  totalRegistrations: null,
  subscriptions: null,
  subscriptionsSum: null,
  error: null,
  loading: false
}

export const GET_TOTAL_REGISTRATIONS_REQUEST = 'GET_TOTAL_REGISTRATIONS_REQUEST'
export const GET_TOTAL_REGISTRATIONS_SUCCESS = 'GET_TOTAL_REGISTRATIONS_SUCCESS'
export const GET_TOTAL_REGISTRATIONS_ERROR = 'GET_TOTAL_REGISTRATIONS_ERROR'

export const GET_SUBSCRIPTIONS_SUMMARY_REQUEST = 'GET_SUBSCRIPTIONS_SUMMARY_REQUEST'
export const GET_SUBSCRIPTIONS_SUMMARY_SUCCESS = 'GET_SUBSCRIPTIONS_SUMMARY_SUCCESS'
export const GET_SUBSCRIPTIONS_SUMMARY_ERROR = 'GET_SUBSCRIPTIONS_SUMMARY_ERROR'

export const getTotalRegistrations = () => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: GET_TOTAL_REGISTRATIONS_REQUEST })
  return httpRequest.get('/summary/registrations')
    .then(response => {
      dispatch({
        type: GET_TOTAL_REGISTRATIONS_SUCCESS,
        totalRegistrations: response.data.totalRegistrations
      })
    })
    .catch(error => {
      dispatch({
        type: GET_TOTAL_REGISTRATIONS_ERROR,
        error: error.response
      })
    })
}

export const getSubscriptionsSummary = params => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: GET_SUBSCRIPTIONS_SUMMARY_REQUEST })
  return httpRequest.get(`/summary/subscriptions?fromDate=${params.fromDate || ''}&toDate=${params.toDate || ''}`)
    .then(response => {
      dispatch({
        type: GET_SUBSCRIPTIONS_SUMMARY_SUCCESS,
        subscriptions: response.data
      })
    })
    .catch(error => {
      dispatch({
        type: GET_SUBSCRIPTIONS_SUMMARY_ERROR,
        error: error.response
      })
    })
}

const ACTION_HANDLERS = {
  [GET_TOTAL_REGISTRATIONS_REQUEST]: state => ({
    ...state,
    totalRegistrations: null,
    loading: true
  }),
  [GET_TOTAL_REGISTRATIONS_SUCCESS]: (state, { totalRegistrations }) => ({
    ...state,
    totalRegistrations,
    loading: false
  }),
  [GET_TOTAL_REGISTRATIONS_ERROR]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  }),
  [GET_SUBSCRIPTIONS_SUMMARY_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [GET_SUBSCRIPTIONS_SUMMARY_SUCCESS]: (state, { subscriptions }) => ({
    ...state,
    ...subscriptions,
    subscriptionsSum: subscriptions.subscriptions.reduce((a, b) => a + b['count'], 0),
    loading: false
  }),
  [GET_SUBSCRIPTIONS_SUMMARY_ERROR]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  })
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/summary.js